import React from 'react';
import '../../styles/ErrorAlert.css';

export default function ErrorAlert({ error, onDismiss, title = 'Error' }) {
  if (!error) return null;

  return (
    <div className="error-alert">
      <div className="error-alert-header">
        <span className="error-alert-icon">⚠️</span>
        <h3 className="error-alert-title">{title}</h3>
        {onDismiss && (
          <button 
            className="error-alert-close" 
            onClick={onDismiss}
            aria-label="Close error"
          >
            ✕
          </button>
        )}
      </div>

      <div className="error-alert-content">
        <p className="error-alert-message">
          {error.message || error.error || 'An error occurred. Please try again.'}
        </p>
      </div>
    </div>
  );
}
